'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('./button.scss');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {

  var handleClick = function handleClick(e) {
    if (typeof props.action === "function") {
      props.action(e);
    }
  };

  var handleHover = function handleHover() {
    if (typeof props.hoverAction === "function") {
      props.hoverAction();
    }
  };

  var icon = void 0;
  if (props.icon) {
    icon = _react2.default.createElement('i', { className: props.icon });
  }

  var customClass = (0, _classnames2.default)((0, _defineProperty3.default)({
    'button': true
  }, props.customClass, true));

  var name = props.name ? _react2.default.createElement(
    'p',
    null,
    props.name
  ) : '';

  return _react2.default.createElement(
    'span',
    { className: customClass, onMouseEnter: handleHover, onClick: handleClick },
    name,
    icon,
    _react2.default.createElement(
      'span',
      { className: 'extraContent' },
      props.text
    )
  );
};

exports.default = Button;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Buttons/Button.jsx
// module id = 711
// module chunks = 0